import type { IconSvgObject } from './types';

const LetterSpacingIcon: IconSvgObject = [
  ["path", { d: "M2 22V2", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M22 22V2", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }],
  ["path", { d: "M16.9976 18L15.1179 13.5M7 18L8.86945 13.5M15.1179 13.5L11.9852 6L8.86945 13.5M15.1179 13.5H8.86945", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "2" }]
];

export default LetterSpacingIcon;
